<template>
  <div class="space-y-5" data-testid="impact-fuehrungsimpuls-detail">
    <div
      v-if="impuls"
      class="rounded-[12px] p-5 border bg-white"
      style="border-color: color-mix(in srgb, var(--color-orange) 20%, transparent)"
      data-testid="impact-impuls-card"
    >
      <div class="flex items-center gap-2 mb-3">
        <span class="text-[18px]" aria-hidden="true">💡</span>
        <span class="text-[14px] font-medium text-[var(--color-dark)]">{{ impuls.updatedLabel }}</span>
        <span v-if="impuls.dimensionHint" class="text-[14px] text-[var(--color-disabled)]">·</span>
        <span
          v-if="impuls.dimensionHint"
          class="text-[14px] font-medium"
          style="color: var(--color-orange)"
        >
          {{ impuls.dimensionHint }}
        </span>
      </div>
      <p class="text-[14px] text-[var(--color-dark)] leading-relaxed mb-3 m-0">
        "{{ impuls.text }}"
      </p>
      <div class="mb-3">
        <p class="text-[12px] text-[var(--color-disabled)] uppercase tracking-wider font-medium mb-1 m-0">
          {{ $t('UserProjects.impactAnalysis.impuls.recommendation') }}
        </p>
        <p class="text-[14px] text-[var(--color-dark)] leading-relaxed m-0">
          {{ impuls.recommendation }}
        </p>
      </div>
      <div class="flex flex-wrap justify-between gap-2 pt-3 border-t border-[#F0F0F0]">
        <p class="text-[12px] text-[var(--color-disabled)] m-0">
          {{ $t('UserProjects.impactAnalysis.impuls.basis') }}: {{ impuls.basis }}
        </p>
        <p class="text-[12px] text-[var(--color-disabled)] m-0">
          {{ $t('UserProjects.impactAnalysis.impuls.updated') }}: {{ impuls.updatedLabel }}
        </p>
      </div>
    </div>
    <p v-else class="text-[14px] text-[var(--color-disabled)] italic m-0">
      {{ $t('UserProjects.impactAnalysis.chain.noImpuls') }}
    </p>

    <ImpactComingSoonPanel
      :title="$t('UserProjects.impactAnalysis.comingSoon.impulsHistoryTitle')"
      :message="$t('UserProjects.impactAnalysis.comingSoon.impulsHistory')"
      test-id="impact-coming-soon-impuls-history"
    />
  </div>
</template>

<script>
import ImpactComingSoonPanel from './ImpactComingSoonPanel.vue';

export default {
  name: 'ImpactFuehrungsimpulsDetail',
  components: { ImpactComingSoonPanel },
  props: {
    impuls: { type: Object, default: null },
  },
};
</script>
